import React  from "react";

/*

*/
const ItemDetailSnippet = (props) => {
  const itemUrl = props.urlBase+props.catalogSlug+"/"+props.categorySlug+"/"+props.item.slug+"/"+props.item.id_e_products;

  //console.log(props);
  const schema = {
    "@context": "http://schema.org",
    "@type": "WebPage",
    breadcrumb: {
      "@context": "http://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: props.urlBase,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: props.catalogSlug,
          item:
            props.urlBase + props.catalogSlug,
        },
        {
          "@type": "ListItem",
          position: 3,
          name: props.categoryName,
          item:
            props.urlBase + props.catalogSlug + "/" + props.categorySlug.trim() + "/" + props.categoryId,
        },
        {
          "@type": "ListItem",
          position: 4,
          name: props.item.nome,
          item: itemUrl,
        },
      ],
    },
    mainEntity: {
      "@context": "http://schema.org",
      "@type": "Product",
      name: props.item.seo_title.length > 0? props.item.seo_title : props.item.nome,
      sku: props.item.codice,
      image: props.item.images[0].url,
      description: props.item.seo_description,
      url: itemUrl,
      brand: {
        "@type": "Brand",
        name: props.categoryName,
      },
      offers: {
        "@type": "Offer",
        availability: "https://schema.org/InStock",
        itemCondition: "https://schema.org/NewCondition",
        price: props.item.prezzo_b2c,
        priceCurrency: "EUR",
      },
    },

  };
 
  return (
    <script
      key={`itemJSON-${props.item.id_e_products}`}
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );    
};

export default ItemDetailSnippet;